var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 19.25L13 14.75L17.5 19.25L19.25 17.5L14.75 13L19.25 8.5L17.5 6.75L13 11.25L8.5 6.75L6.75 8.5L11.25 13L6.75 17.5L8.5 19.25ZM13 25.5C11.2708 25.5 9.64584 25.1717 8.125 24.515C6.60417 23.8583 5.28125 22.9679 4.15625 21.8438C3.03125 20.7196 2.14084 19.3967 1.485 17.875C0.829168 16.3533 0.500835 14.7283 0.500002 13C0.499168 11.2717 0.827502 9.64667 1.485 8.125C2.1425 6.60333 3.03292 5.28042 4.15625 4.15625C5.27958 3.03208 6.6025 2.14167 8.125 1.485C9.6475 0.828333 11.2725 0.5 13 0.5C14.7275 0.5 16.3525 0.828333 17.875 1.485C19.3975 2.14167 20.7204 3.03208 21.8438 4.15625C22.9671 5.28042 23.8579 6.60333 24.5163 8.125C25.1746 9.64667 25.5025 11.2717 25.5 13C25.4975 14.7283 25.1692 16.3533 24.515 17.875C23.8608 19.3967 22.9704 20.7196 21.8438 21.8438C20.7171 22.9679 19.3942 23.8587 17.875 24.5162C16.3558 25.1737 14.7308 25.5017 13 25.5Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundCross);
export default __webpack_public_path__ + "static/media/round-cross.b0373d4aa757f1ed47ff38020478911b.svg";
export { ForwardRef as ReactComponent };